import { render } from "./XiSanAboutView.vue?vue&type=template&id=6a492100&scoped=true"
import script from "./XiSanAboutView.vue?vue&type=script&lang=js"
export * from "./XiSanAboutView.vue?vue&type=script&lang=js"

import "./XiSanAboutView.vue?vue&type=style&index=0&id=6a492100&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a492100"]])

export default __exports__